module.exports = __webpack_public_path__ + "img/text_pred.11711146.png";